import React from 'react'
import './BarChart.css'

const BarChart = ({ title, data }) => {
  // Handle empty data
  const safeData = data && data.length > 0 ? data : []
  const maxValue = safeData.length > 0 
    ? Math.max(...safeData.map(item => item.value || 0), 100) 
    : 100
  const chartHeight = 200
  const barWidth = 40
  const barSpacing = 20
  const chartWidth = safeData.length > 0 
    ? safeData.length * (barWidth + barSpacing) + barSpacing 
    : 400

  return (
    <div className="chart-card">
      <h2 className="chart-title">{title}</h2>
      <div className="bar-chart-container">
        <svg viewBox={`0 0 ${chartWidth} ${chartHeight + 40}`} className="bar-chart-svg" preserveAspectRatio="xMidYMid meet">
          {/* Y-axis grid lines */}
          {[0, 25, 50, 75, 100].map((val) => {
            const y = chartHeight - (val / maxValue) * chartHeight
            return (
              <g key={val}>
                <line
                  x1="0"
                  y1={y}
                  x2={chartWidth}
                  y2={y}
                  stroke="#f1f5f9"
                  strokeWidth="1"
                />
                <text
                  x="0"
                  y={y + 4}
                  fontSize="12"
                  fill="#64748b"
                  textAnchor="start"
                >
                  {val}
                </text>
              </g>
            )
          })}
          
          {/* Bars */}
          {safeData.length > 0 ? (
            safeData.map((item, index) => {
              const x = barSpacing + index * (barWidth + barSpacing)
              const barHeight = ((item.value || 0) / maxValue) * chartHeight
              const y = chartHeight - barHeight
              
              return (
                <g key={index}>
                  <rect
                    x={x}
                    y={y}
                    width={barWidth}
                    height={barHeight}
                    fill="#7c3aed"
                    rx="4"
                  />
                  <text
                    x={x + barWidth / 2}
                    y={y - 5}
                    fontSize="10"
                    fill="#64748b"
                    textAnchor="middle"
                  >
                    {item.value || 0}
                  </text>
                </g>
              )
            })
          ) : (
            <text
              x={chartWidth / 2}
              y={chartHeight / 2}
              fontSize="14"
              fill="#64748b"
              textAnchor="middle"
            >
              No data available
            </text>
          )}
        </svg>
        
        {/* X-axis labels */}
        <div className="bar-chart-x-axis">
          {safeData.length > 0 ? (
            safeData.map((item, index) => (
              <span key={index} className="bar-x-axis-label">
                {item.label}
              </span>
            ))
          ) : (
            <span className="bar-x-axis-label" style={{ textAlign: 'center', width: '100%' }}>
              No data available
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default BarChart




